<template>
  <div
    id="app"
    v-scroll="handleScroll"
    :class="{
      ltr_ecommerce: css_direction === 'ltr',
      rtl_ecommerce: css_direction === 'rtl',
      'ltr-on-rtl': !$store.getters.orientation && css_direction === 'rtl',
      rtl: $store.getters.orientation && css_direction === 'ltr',
    }"
  >
    <div
      class="container_main data-container"
      v-if="$store.getters.outlet || webviewGuard === true"
      :style="{
        visibility:
          $store.getters.modal.search &&
          $store.getters.search &&
          $store.getters.search.query &&
          $store.getters.search.query.length > 0
            ? 'hidden'
            : 'visible',
      }"
    >
      <block-popup v-if="$store.getters.modal.block"></block-popup>
      <TopBar v-if="$store.getters.outlet && !$store.getters.isBookingMode" />

      <transition :name="'header-fade'" mode="out-in">
        <Header v-if="$route.name === 'home' && $store.getters.outlet" />
      </transition>
      <!--                        <BubblesNavbar v-if="($route.name === 'home' || $route.name === 'catalog')  && $store.getters.outlet && $store.getters.categories.length > 1"/>-->
      <keep-alive>
        <transition :name="transition" mode="out-in">
          <router-view />
        </transition>
      </keep-alive>
      <!-- <Basket /> -->
      <!--<ProductDetailed/>-->
    </div>
    <Footer
      v-if="
        ($route.name === 'home' || $route.name === 'catalog') &&
        $store.getters.outlet &&
        !$store.getters.overlay
      "
    />
    <div
      class="container_main modal-container"
      v-show="$store.getters.outlet"
      :style="{ minHeight: '0' }"
    >
      <CallWaiterModal />
      <SearchModal />
      <SystemPopup />
      <Product
        v-if="
          $store.getters.outletSettings &&
          $store.getters.outletSettings.delivery_type !== 4
        "
      />
      <Resource
        v-if="
          $store.getters.outletSettings &&
          $store.getters.outletSettings.delivery_type === 4
        "
      />
      <DateFilter
        v-if="
          $store.getters.outletSettings &&
          $store.getters.outletSettings.delivery_type === 4
        "
      />
    </div>
  </div>
</template>

<script>
import "@/lazyLoadLib";
import sanitizeHtml from "sanitize-html";
import "../../../node_modules/noty/src/noty.scss";
import "../../../node_modules/noty/src/themes/sunset.scss";
// import intlTelInput from 'intl-tel-input'
import {
  FETCH_OUTLET,
  FETCH_PRODUCTS,
  GET_BASKET,
  GET_TEXTS,
} from "@/store/actions.type";
import Cookies from "js-cookie";
import sha256 from "crypto-js/sha256";
import randomBytes from "randombytes";
import { mapGetters } from "vuex";
import {
  SET_CLIENT_INFO,
  SET_CONTACTLESS_MODE,
  SET_CONTAINER,
  SET_IDENTITY,
  SET_LOADING,
  SET_MODAL,
  SET_QUERY_PARAMS,
  SET_SELECTED_CATEGORY,
  SET_STATUS,
  SET_TIME,
  SET_TOKEN,
  SET_WEBVIEW_GUARD,
  SET_CSS_DIRECTION,
} from "@/store/mutations.type";
import VueGtm from "vue-gtm";
import Vue from "vue";
import BlockPopup from "@/components/Default/BlockPopup";
import CallWaiterModal from "@/components/ECommerce/CallWaiterModal";
import SystemPopup from "@/components/Default/Modals/SystemPopup";
import loader from "@/loader";
import BubblesNavbar from "@/components/ECommerce/BubblesNavbar";
import Product from "@/components/ECommerce/Products/Product";
// import Basket from '@/components/ECommerce/Basket'
import SearchModal from "@/components/ECommerce/SearchModal";
import ProductDetailed from "@/components/ECommerce/Products/ProductDetailed";
import Resource from "@/components/Default/Resource/Resource";
import DateFilter from "@/components/Default/Resource/DateFilter";

Vue.prototype.sanitize = (dirty) => {
  return sanitizeHtml(dirty, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"]),
  });
};
// global.intlTelInput = intlTelInput

console.log("app ecom");

export default {
  name: "App",
  data: () => ({
    css_direction: "",
  }),
  components: {
    DateFilter,
    Resource,
    SearchModal,
    SystemPopup,
    CallWaiterModal,
    // Basket,
    Product,
    ProductDetailed,
    BubblesNavbar,
    BlockPopup,
    TopBar: () => import("@/" + loader.component("TopBar")),
    Header: () => import("@/" + loader.component("Header")),
    Footer: () => import("@/" + loader.component("Footer")),
  },
  async mounted() {
    if (
      window.location.search.substring(0, 7) === "?random" &&
      window.self !== window.top
    ) {
      parent.postMessage("dgsnWidget.close", "*");
    }
    this.css_direction = loader.css_direction;
    await this.$store.commit(SET_CSS_DIRECTION, this.css_direction);
    const _this = this;
    window.extAsyncInit = function () {
      if (MessengerExtensions.isInExtension()) {
        return _this.$store.commit(
          SET_CONTAINER,
          _this.$store.getters.const.CONTAINER_FACEBOOK
        );
      }
      if (window.self !== window.top) {
        return _this.$store.commit(
          SET_CONTAINER,
          _this.$store.getters.const.CONTAINER_IFRAME
        );
      }
      return _this.$store.commit(
        SET_CONTAINER,
        _this.$store.getters.const.CONTAINER_TAB
      );
    };

    await this.$store.commit(SET_TOKEN, token);

    let urlParams = new URLSearchParams(window.location.search);
    let contactlessMode;
    await this.$store.commit(
      SET_QUERY_PARAMS,
      btoa(
        JSON.stringify({
          t: urlParams.get("t"),
        })
      )
    );
    if (urlParams.get("t")) {
      contactlessMode = true;
      this.$store.commit(SET_CONTACTLESS_MODE, true);
    }

    let cookie = Cookies.get("identity");
    if (!cookie && token) {
      cookie = sha256(token + randomBytes(64) + Date.now()).toString();
      Cookies.set("identity", cookie, { expires: 365 });
    }

    await this.$store.commit(SET_IDENTITY, cookie);

    let webp = false;

    await this.checkWebpFeature("lossy", function (feature, isSupported) {
      if (isSupported) {
        let sBrowser,
          sUsrAg = navigator.userAgent;
        if (sUsrAg.indexOf("Safari") > -1) {
          sBrowser = "Apple Safari";
        } else {
          sBrowser = "unknown";
        }
        if (
          (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            navigator.userAgent
          ) &&
            window.innerWidth < 376) ||
          sBrowser === "Apple Safari"
        ) {
          webp = false;
        } else {
          webp = true;
        }
      }
    });

    let clientInfo = {
      browserWidth: window.innerWidth,
      browserHeight: window.innerHeight,
      webpSupport: webp,
    };
    this.$store.commit(SET_CLIENT_INFO, JSON.stringify(clientInfo));

    if (token === process.env.VUE_APP_WEB_TOKEN && !contactlessMode) {
      this.$store.commit(SET_WEBVIEW_GUARD, true);
    } else {
      this.$store.commit(SET_WEBVIEW_GUARD, false);
    }

    this.$store.dispatch(GET_TEXTS);

    setInterval(() => {
      this.$store.commit(SET_TIME);
    }, 1000 * 60);

    this.$store.subscribe((mutation) => {
      if (mutation.type === SET_SELECTED_CATEGORY) {
        this.$store.commit(SET_LOADING, {
          process: FETCH_PRODUCTS,
          loading: false,
        });
        if (
          mutation.payload &&
          mutation.payload.id &&
          ((this.$store.getters.outletSettings.delivery_type !== 4 &&
            mutation.payload.dishes_count > 0) ||
            (this.$store.getters.outletSettings.delivery_type === 4 &&
              mutation.payload.resources_count > 0))
        ) {
          if (this.$store.getters.products[mutation.payload.id].meta.loaded) {
            return;
          }

          this.$store.dispatch(FETCH_PRODUCTS, {
            category_id: mutation.payload.id,
          });
        }
      }
    });
  },

  methods: {
    handleScroll: function () {
      let element = document.getElementById("topBar");
      if (element) {
        if (window.scrollY < 65) {
          if (
            Object.entries(this.$store.getters.modal).some(
              (el) => el[1] === true
            )
          )
            return;
          element.classList.remove("collapsed");
        } else {
          if (this.$route.name === "catalog") {
            element.classList.add("collapsed");
          }
        }
      }
    },

    startWebview() {
      if (this.$store.getters.token === process.env.VUE_APP_WEB_TOKEN) {
        this.$store.dispatch(FETCH_OUTLET, {
          page: 1,
          only_popular: true,
          get_settings: true,
        });
      } else {
        this.$store.dispatch(FETCH_OUTLET, {
          page: 1,
          only_popular: true,
          get_settings: true,
        });
        this.$store.dispatch(GET_BASKET);
      }

      let clickHandler =
        "ontouchstart" in document.documentElement ? "touchstart" : "click";

      document.addEventListener(
        clickHandler,
        (event) => {
          if (event.target.classList.contains("popup_click_hide")) {
            event.stopPropagation();
            setTimeout(() => {
              for (let name in this.$store.getters.modal) {
                if (name !== "block") {
                  if (this.$store.getters.modal[name] === true) {
                    this.$store.commit(SET_MODAL, {
                      modal: name,
                      status: false,
                    });
                    break;
                  }
                }
              }
            }, 100);
            return false;
          }
        },
        false
      );
    },
    checkWebpFeature(feature, callback) {
      return new Promise((resolve, reject) => {
        var kTestImages = {
          lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
          lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
          alpha:
            "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
          animation:
            "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",
        };
        var img = new Image();
        img.onload = function () {
          var result = img.width > 0 && img.height > 0;
          resolve(callback(feature, result));
        };
        img.onerror = function () {
          resolve(callback(feature, false));
        };
        img.src = "data:image/webp;base64," + kTestImages[feature];
      });
    },
  },

  computed: {
    transition() {
      const css_direction = loader.css_direction;
      if (
        (this.$route.name === "receipt" && css_direction === "rtl") ||
        (this.$route.name === "form" && css_direction === "rtl")
      ) {
        return "rtl-slide-fade";
      } else if (
        this.$route.name === "receipt" ||
        this.$route.name === "form"
      ) {
        return "slide-fade";
      }
      return "view-fade";
    },
    ...mapGetters(["webviewGuard", "gtmTag"]),
  },

  watch: {
    webviewGuard(webviewGuard) {
      if (webviewGuard === false) {
        this.startWebview();
      } else {
        this.$router.push({
          name: "guard",
          params: { token: this.$store.getters.token },
        })
      }
    },
    gtmTag(gtmTag) {
      if (gtmTag) {
        Vue.use(VueGtm, {
          id: gtmTag, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
          enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
          debug: false, // Whether or not display console logs debugs (optional)
          loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
          vueRouter: this.$router, // Pass the router instance to automatically sync with router (optional)
        });
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  max-height: 100vh;
  padding-top: 0;
}
</style>
